import AppRoutes from "./routes/AppRoutes";

//import { AuthProvider } from "./Context/AuthContext";
function App() {
  return <AppRoutes />;
}

export default App;
